module.exports = __webpack_public_path__ + "img/head_five.4e082002.png";